import { BoxProps, Box as MuiBox } from '@mui/material';
import React from 'react';

export const Box = ({ children, ...props }: BoxProps) => {
    return <MuiBox {...props}>{children}</MuiBox>;
};
